export const useUrlParams = () => {
    const { pathname } = window.location
    const split = pathname.split('/')

    return {
        customer: split[1],
        trackingId: split[2],
    }
}
